import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ChevronLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.5 3.5L6 8L10.5 12.5" stroke={color} />
    </svg>
  ),
)

ChevronLeft.displayName = 'ChevronLeft'

ChevronLeft.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default ChevronLeft
